export default __webpack_public_path__ + "static/media/portfolio-115.ad421503.jpg";